const commissionsTabs = {
  COMMISSION_FULL_DATA: 'COMMISSION_FULL_DATA',
  COMMISSION_BY_USER: 'COMMISSION_BY_USER',
};

export {
  commissionsTabs,
};
